import React from 'react'
import DashboardPopup from 'modules/dashboard/DashboardPopup/DashboardPopup'
import styled from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import Button from 'components/UI/Button/Button'
import Selector from './Selector'
import CountryCurrency from 'data/static/country-currency.json'
import PropTypes from 'prop-types'

export const Title = styled.div`
  color: ${colors.pink};
  font-size: 28px;
  text-align: center;
  margin-bottom: 15px;
`

export const SelectButton = styled(Button)`
  margin-top: 15px;
`

export const SizeButton = styled(Button)`
  margin-top: 15px;
`

export const ConfirmButton = styled(Button)`
  margin-top: 60px;
`

export const Content = styled.div`
  text-align: center;
`

export const SelectedChoice = styled.div`
  font-size: 28px;
  color: ${colors.darkPurple};
  margin: 10px 0 5px 0;
`

export const PricePerClass = styled.div`
  color: ${colors.pink};
  margin-bottom: 5px;
`

const PLANS = [
  { nbClasses: 1, prices: { 'gbp': '£230.00', 'usd': '$300.00', 'nzd': '$400.00', 'aud': '$400.00', 'eu': '€260.00' } },
  { nbClasses: 2, prices: { 'gbp': '£437.00', 'usd': '$570.00', 'nzd': '$760.00', 'aud': '$760.00', 'eu': '€494.00' } },
  { nbClasses: 3, prices: { 'gbp': '£655.50', 'usd': '$855.00', 'nzd': '$1,140.00', 'aud': '$1,140.00', 'eu': '€741.00' } },
  { nbClasses: 4, prices: { 'gbp': '£874.00', 'usd': '$1,140.00', 'nzd': '$1,520.00', 'aud': '$1,520.00', 'eu': '€988.00' } },
  { nbClasses: 5, prices: { 'gbp': '£1,092.50', 'usd': '$1,425.00', 'nzd': '$1,900.00', 'aud': '$1,900.00', 'eu': '€1,235.00' } },
  { nbClasses: 6, prices: { 'gbp': '£1,311.00', 'usd': '$1,710.00', 'nzd': '$2,280.00', 'aud': '$2,280.00', 'eu': '€1,482.00' } },
  { nbClasses: 7, prices: { 'gbp': '£1,529.50', 'usd': '$1,995.00', 'nzd': '$2,660.00', 'aud': '$2,660.00', 'eu': '€1,729.00' } },
  { nbClasses: 8, prices: { 'gbp': '£1,748.00', 'usd': '$2,280.00', 'nzd': '$3,040.00', 'aud': '$3,040.00', 'eu': '€1,976.00' } },
  { nbClasses: 9, prices: { 'gbp': '£1,966.50', 'usd': '$2,565.00', 'nzd': '$3,420.00', 'aud': '$3,420.00', 'eu': '€2,223.00' } },
  { nbClasses: 10, prices: { 'gbp': '£2,185.00', 'usd': '$2,850.00', 'nzd': '$3,800.00', 'aud': '$3,800.00', 'eu': '€2,470.00' } },
  { nbClasses: 11, prices: { 'gbp': '£2,403.50', 'usd': '$3,135.00', 'nzd': '$4,180.00', 'aud': '$4,180.00', 'eu': '€2,717.00' } },
  { nbClasses: 12, prices: { 'gbp': '£2,622.00', 'usd': '$3,420.00', 'nzd': '$4,560.00', 'aud': '$4,560.00', 'eu': '€2,964.00' } },
  { nbClasses: 13, prices: { 'gbp': '£2,840.50', 'usd': '$3,705.00', 'nzd': '$4,940.00', 'aud': '$4,940.00', 'eu': '€3,211.00' } },
  { nbClasses: 14, prices: { 'gbp': '£3,059.00', 'usd': '$3,990.00', 'nzd': '$5,320.00', 'aud': '$5,320.00', 'eu': '€3,458.00' } },
  { nbClasses: 15, prices: { 'gbp': '£3,277.50', 'usd': '$4,275.00', 'nzd': '$5,700.00', 'aud': '$5,700.00', 'eu': '€3,705.00' } },
  { nbClasses: 16, prices: { 'gbp': '£3,496.00', 'usd': '$4,560.00', 'nzd': '$6,080.00', 'aud': '$6,080.00', 'eu': '€3,952.00' } },
  { nbClasses: 17, prices: { 'gbp': '£3,714.50', 'usd': '$4,845.00', 'nzd': '$6,460.00', 'aud': '$6,460.00', 'eu': '€4,199.00' } },
  { nbClasses: 18, prices: { 'gbp': '£3,933.00', 'usd': '$5,130.00', 'nzd': '$6,840.00', 'aud': '$6,840.00', 'eu': '€4,446.00' } },
  { nbClasses: 19, prices: { 'gbp': '£4,151.50', 'usd': '$5,415.00', 'nzd': '$7,220.00', 'aud': '$7,220.00', 'eu': '€4,693.00' } },
  { nbClasses: 20, prices: { 'gbp': '£4,370.00', 'usd': '$5,700.00', 'nzd': '$7,600.00', 'aud': '$7,600.00', 'eu': '€4,940.00' } }
]

class ClassesNumberPopup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selecting: false,
      selected: false
    }
    this.onSelectAction = this.onSelectAction.bind(this)
    this.selectNbClasses = this.selectNbClasses.bind(this)
    this.onSelectAction = this.onSelectAction.bind(this)
    this.requestInvoice = this.requestInvoice.bind(this)
  }

  static propTypes = {
    countryCode: PropTypes.string,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func
  }

  selectNbClasses (o) {
    this.setState({
      selected: true,
      selecting: false,
      choice: o
    })
  }

  onSelectAction () {
    this.setState({
      selecting: true
    })
  }

  renderNotSelectedView () {
    return [<div key='1'><SelectButton block={false} onClick={this.onSelectAction}>Select</SelectButton></div>,
      <div key='2'><ConfirmButton disabled>Request Invoice</ConfirmButton></div>]
  }

  renderSelectingContent () {
    let currency
    if (!CountryCurrency[this.props.countryCode]) { currency = 'usd' } else {
      currency = CountryCurrency[this.props.countryCode].toLowerCase()
    }

    return <Selector options={PLANS.map(p => (
      { plan: p, label: `${p.nbClasses} Class${p.nbClasses > 1 ? 'es' : ''}`, info: `${p.prices[currency]}` }
    ))} onSelect={this.selectNbClasses} />
  }

  requestInvoice () {
    this.props.onSubmit([{ title: 'Type', answer: 'Multiple classes' }, { title: 'Number of classes', answer: `${this.state.choice.plan.nbClasses}` }])
  }

  renderSelectedContent () {
    const { choice } = this.state
    return [
      <SizeButton key='1' onClick={this.onSelectAction}>{choice.label}</SizeButton>,
      <SelectedChoice key='2'>{choice.info}</SelectedChoice>,
      <PricePerClass key='3'>Only {choice.info[0]}{parseInt(choice.info.substring(1, choice.info.length).replace(',', '')) / choice.plan.nbClasses} per class</PricePerClass>,
      <Button key='4' bgColor={colors.success} onClick={this.requestInvoice}>Request Invoice</Button>
    ]
  }

  render () {
    return <DashboardPopup
      onCancel={this.props.onCancel}
    >
      <Title>
        How many classes do you need?
      </Title>

      <Content>
        { !this.state.selecting && !this.state.selected && this.renderNotSelectedView() }
        { this.state.selecting && this.renderSelectingContent() }
        { !this.state.selecting && this.state.selected && this.renderSelectedContent() }

      </Content>
    </DashboardPopup>
  }
}

export default ClassesNumberPopup
